module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/238-thailand-628f0f85ecf3ed1e11bec36191a865c7.svg";